import React, { useState } from 'react';
import md5 from 'md5';
import {
  minLength,
  PasswordInput,
  required,
  useNotify,
  useTranslate,
} from 'react-admin';
import { Form } from 'react-final-form';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import AccordionActions from '@material-ui/core/AccordionActions';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import { apiPut } from '../brainApi';

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from './SettingsUtils';

const useStyles = makeStyles((theme) => ({
  form: {
    padding: '0 1em 1em 1em',
  },
  input: {
    width: '100%',
  },
  button: {
    width: '100%',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  w100: {
    width: '100%',
  },
  settingsThemeContainer: {
    width: '50%',
    margin: '20px auto 0 auto',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 25px) !important',
      margin: '10px auto 0px auto !important',
    },
  },
}));

const ChangePassword = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={classes.settingsThemeContainer}>
      <ExpansionPanel
        square
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
      >
        <ExpansionPanelSummary
          aria-controls="panel1d-content"
          expandIcon={<ExpandMoreIcon />}
          id="panel1d-header"
        >
          <Typography>Change password</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div className={classes.w100}>
            <ChangeForm setExpanded={setExpanded} />
          </div>
        </ExpansionPanelDetails>
        <Divider />
      </ExpansionPanel>
    </div>
  );
};

export default ChangePassword;

const ChangeForm = ({ setExpanded }) => {
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const translate = useTranslate();
  const notify = useNotify();

  const submit = ({ password, password2 }) => {
    if (password !== password2) {
      notify(translate('auth.passwords_do_not_match'), 'warning');
      return;
    }
    const payload = {
      md5: md5(password),
    };
    setLoading(true);
    apiPut('/change-password', payload, false)
      .then(() => {
        setLoading(false);
        notify('Password updated succesfully', 'info');
        setExpanded(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Form
      onSubmit={submit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className={classes.form}>
            <PasswordInput
              className={classes.input}
              source="password"
              label="auth.new_password_1"
              inputProps={{ autoComplete: 'new-password' }}
              validate={[required(), minLength(6)]}
            />
            <br />
            <PasswordInput
              className={classes.input}
              source="password2"
              label="auth.new_password_2"
              inputProps={{ autoComplete: 'new-password' }}
              validate={[required(), minLength(6)]}
            />
          </div>
          <AccordionActions>
            <Button
              type="submit"
              size="small"
              color="primary"
              variant="contained"
            >
              {loading && (
                <CircularProgress
                  className={classes.icon}
                  size={18}
                  thickness={2}
                  color="inherit"
                />
              )}
              {translate('auth.set_new_password')}
            </Button>
          </AccordionActions>
        </form>
      )}
    />
  );
};
